import './preview-link-dialog.component.css';

const previewLinkDialogConfig = {
    selector: 'mwPreviewLinkDialog',
    bindings: {
      linkToHtml: '<'
    },
    template: `
        <mw-mini-modal-dialog 
            class="mw-mini-modal-dialog mw-mini-modal--wide" 
            aria-label="" 
            layout="column" 
            flex
            title="{{$ctrl.$translate.instant('newsletters__dialog-title--nld-html')}}" 
            ok="{{$ctrl.$translate.instant('OK')}}" 
            on-ok="$ctrl.handleOK()">
            
            <mw-modal-content>
               <div class="mw-dialog__text-content">
               <div>
                   <div class="showLinksBox">
                       <div class="showLinksText">
                           <div class="linksLabel">{{$ctrl.$translate.instant('newsletters__form-label--nld-html')}}</div>
                           <textarea class="linksFormat" rows="3" id="nld_html_link">{{$ctrl.linkToHtml}}</textarea>
                       </div>
                       <div class="showLinksAction">
                            <md-button class="mw-button clipboard_btn" data-clipboard-target="#nld_html_link">{{$ctrl.$translate.instant('Copy')}}</md-button>
                       </div>
                   </div>
               </div>
            </mw-modal-content>
        </mw-mini-modal-dialog>
    `,
    controller: null
};

class PreviewLinkDialog {
    constructor(
        private $mdDialog,
        private $translate
    ) {
        'ngInject';
        new Clipboard('.clipboard_btn');
    }

    handleOK() {
        this.$mdDialog.hide();
    }
}

previewLinkDialogConfig.controller = PreviewLinkDialog;

export {
    previewLinkDialogConfig,
    PreviewLinkDialog as default
}



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/preview-link-dialog/preview-link-dialog.component.ts
 **/